// extracted by mini-css-extract-plugin
export default {"CreditCardInfoIcon":"Icon_CreditCardInfoIcon__2-etV"};